import { ComponentType, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import useAppModal from 'hooks/useAppModal';
import useAppSelector from 'hooks/useAppSelector';

const WebsiteSettingsModalRoute = ({
  modal: ModalComponent,
  modalId,
}: {
  modal: ComponentType<{ onClose: () => void }>;
  modalId: string;
}) => {
  const navigate = useNavigate();
  const { closeModal, openModal } = useAppModal();
  const isOpen = useAppSelector((state) => !!state.modal.activeModals[modalId]);
  const hasOpened = useRef(false);

  useEffect(() => {
    const onClose = () => navigate('../', { replace: true });

    openModal({
      closeOnHide: false,
      customContent: <ModalComponent onClose={onClose} />,
      id: modalId,
      onHide: onClose,
    });

    return () => closeModal(modalId);
  }, [closeModal, ModalComponent, modalId, navigate, openModal]);

  // Navigating on save would be blocked by the still-dirty form, so follow the modal closing instead.
  useEffect(() => {
    if (isOpen) {
      hasOpened.current = true;
    } else if (hasOpened.current) {
      navigate('../', { replace: true });
    }
  }, [isOpen, navigate]);

  return null;
};

export default WebsiteSettingsModalRoute;
